<template>
    <header class="header">
        <div @click="openSidebar" class="header__item header__item--action">
            <icon type="menu" size="24" />
        </div>
        <template v-if="channel">

            <channel-navigation />

            <div class="header__item header__item--large">
                <aside @click="openSearch" class="header__search header__item header__item--action">
                    <icon type="search" color="bluegray" size="24" />
                    <p class="header__search__input">Search this channel</p>
                </aside>
                <img src="/images/skybaseit-beta-inverse.svg" alt="Skybase.it" class="header__logo">
            </div>

        </template>
        <template v-else>
            <div class="header__item header__item--large">
                <img src="/images/skybaseit-beta-inverse.svg" alt="Skybase.it" class="header__logo">
            </div>
        </template>

        <user-navigation v-if="isMobile === false" />

        <div v-if="isMobile === false" @click="openNotifications" class="header__item header__item--action">
            <icon type="bell" color="bluegray" size="24" />
            <span v-if="hasNotifications" class="lc-has-notifications notifications__badge"></span>
        </div>

        <mobile-navigation v-if="isMobile" />
    </header>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { OPEN_SIDEBAR, OPEN_NOTIFICATIONS, OPEN_SEARCH, SWITCH_CHANNEL } from '../../stores/global/mutations'
import Device from '../../mixins/deviceAware'
import Icon from '../Global/Icon'
import UserNavigation from './UserNavigation'
import MobileNavigation from './MobileNavigation'
import ChannelNavigation from './ChannelNavigation'

export default {
    name: 'Header',

    mixins: [Device],

    components: {
        Icon,
        UserNavigation,
        MobileNavigation,
        ChannelNavigation
    },

    props: {
        channelId: {
            required: false,
            type: Number,
            default: null
        }
    },

    created () {
        if (this.channelId) {
            this.setCurrentChannel(this.channelId)
        }
    },

    computed: {
        ...mapState(['isSearchOpen']),
        ...mapState('channel', ['channel']),
        ...mapState('notifications', ['notifications']),

        hasNotifications () {
            return this.notifications.length > 0
        }
    },

    methods: {
        ...mapMutations({
            setCurrentChannel: SWITCH_CHANNEL,
            openSidebar: OPEN_SIDEBAR,
            openNotifications: OPEN_NOTIFICATIONS,
            openSearch: OPEN_SEARCH
        })
    }
}
</script>
